import { FC } from 'react';
import { Box, Container, Stack } from '@mui/material';
// import ErrorBoundary from '../HOC/ErrorBoundaries';
import { LanguageSwitcher } from '../organisms/layout/navbar/LanguageSwitcher';

type LoginTemplatePropsType = {
  children: any;
};

const LoginTemplate: FC<LoginTemplatePropsType> = ({ children }) => {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: '100%',
          height: '100vh',
          backgroundColor: 'customGrey.background',
          position: 'relative',
          minHeight: '600px',
          minWidth: '300px',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: { xs: 10, sm: 15, md: 20 },
            top: { xs: 10, sm: 15, md: 20 },
          }}
        >
          <LanguageSwitcher />
        </Box>
        <Container
          maxWidth="lg"
          sx={{
            height: { xs: '100%', md: 'auto' },
            p: { xs: 0, md: 'auto' },
            m: { xs: 0, md: 'auto' },
            borderRadius: { xs: 0, md: 'auto' },
          }}
        >
          {children}
        </Container>
      </Stack>
    </>
  );
};

export default LoginTemplate;
